import { stringify } from 'query-string';
import * as R from 'ramda';

const apiUrl = process.env.REACT_APP_BACKEND_HOST;

const zoomAttendanceProvider = {
  getManyReference: async (params) => {
    const options = {
      method: 'POST',
      body: JSON.stringify(params.search),
      headers: { 'Content-Type': 'application/json' },
    };
    const page = params.pagination.page;
    const limit = params.pagination.perPage;
    const sortPrefix =
      R.pathOr('ASC', ['sort', 'order'], params) === 'DESC' ? '-' : '';
    const sort = `${sortPrefix}${R.pathOr('id', ['sort', 'field'], params)}`;
    const query = {
      sort,
      page,
      limit,
    };
    const url = `${apiUrl}/zoom_attendance/search?${stringify(query)}`;
    return { url, options };
  },
};

export default zoomAttendanceProvider;
